module.exports = __webpack_public_path__ + "img/betaCorner_DD_v3.d3e97ac7.svg";